module.exports = __webpack_public_path__ + "static/media/edit-button-inverted.46691b7d.svg";